import React, { Children, useContext, useEffect, useState } from 'react'
import MessageTypes from '../ActiveChatInfo/MessageTypes'
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Avatar from '../Avatar';
import styles from './styles.module.css';
import CookieFunction from '../../functions/cookieFunction';
import MessageDateSeen from '../MessageDateSeeen';
import AppIcons from '../../icons';
import CenterModal from '../CenterModal';
import ConfirmationButton from '../ConfirmationButton';
import ConfirmModal from '../ConfirmModal';


export default function SingleMessage({content, item, children, favFunction}) {

  let channelId = CookieFunction('get', 'userAuthOchatt');
  const [contact, setContact] =useState(item?.roomUser?.channelUser?.uuid !=
  channelId)
  const [openConfirm,setOpenConfirm]= useState(null)
  
  useEffect(()=>{
    setContact(item?.roomUser?.channelUser?.uuid !=
      channelId)
  },[item])
  return (
    <>
    <div className={`message__chats ${!contact? `flex-row ${styles.myMessage}` : 'flex-row-reverse'} rtl`}>

        {contact && 
              <Avatar
            width={37}
            height={37}
            containerclassName={`cursor-pointer`}
            className={`cursor-pointer roundBox`}
            src={
              item?.roomUser?.channelUser?.image
                ?.name
                ? item?.roomUser?.channelUser
                    ?.image?.name
                : blanckUser
            }
            local={
              !item?.roomUser?.channelUser?.image
                ?.name
            }
            onClick={() => {
              showUserInfoFunction(
                item?.roomUser?.channelUser?.uuid
              );
            }}
          />
          }
            <div className={`${!contact ? 'message__sender message_sent' : 'message__recipient message_recieved ' }`}>
                
              <div
                className={`flex flex-col justify-start items-start w-auto ml-auto ${styles.extraSpace}`}
              >

                <div  className={styles.content}>
                {favFunction != null && <div className={`${styles.removeFav} ${!contact && styles.left}`} onClick={(e)=>{e.preventDefault();e.stopPropagation(); setOpenConfirm({id: item?.id, roomId: item?.roomId})}}>
                  <AppIcons.closeIcon width={'10px'} height={'10px'} fill={contact ? '#555' : '#555'} className={`noFilterSvg cursor-pointer`}/>
                </div>}
        {children}


        <MessageDateSeen item={item} />

          </div>


      </div>
    </div>
  </div>
  {openConfirm != null && 
  <CenterModal
              handleShowModal={() => {
                setOpenConfirm(null);
              }}
              extraContentInsideClass={`confirmModal`}
            >
                        <ConfirmModal        
                        text={content?.deleteFav?.description}      confirmText={content?.deleteFav?.confirmText}
                        rejectText={content?.deleteFav?.rejectText}
                        confirmFunction={(e) => {
                          favFunction({id: openConfirm?.id, roomId: openConfirm?.roomId})
                          setOpenConfirm(null);
                        }}
                        rejectFunction={() => {
                          setOpenConfirm(null);
                        }}/>
            </CenterModal>
}
</>
  )
}
